var map = {
	"./en/3-1/3_1tit.png": 2168,
	"./fi/3-1/3_1tit.png": 34350,
	"./in/3-1/3_1tit.png": 12884,
	"./th/3-1/3_1tit.png": 28755,
	"./tw/3-1/3_1tit.png": 13826,
	"./zh/3-1/3_1tit.png": 9497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49940;